import { BaseEntity } from "./_base.types";

export interface AccountLicenseLineEntity {
  accountLicenseLineID: string;
  licenseCode: string;
  licenseName: string;
  quantity: number;
  type: "core" | "addon";
  entitlementsAccess: LicenseAccessKeys[];
  entitlementsLimits: Partial<Record<LicenseLimitKeys, number>>;
  entitlementsUsers: number;
}

/**
 * This is used on both the front end and backend to control what an account can access
 */
export interface AccountLicenseEntitlementsEntity {
  name: string;
  hasAccess: boolean;
  users: number;
  entitlements: AccountLicenseEntitlements;
}

// License stuff

// for each type we have up to 3 limits
// count - For items that arent records lol
// records - For items that are records
// objecttypes - For the number of object types

// These are only the limits that can vary between standard and pro (and other types of license)
// Other limits exist but dont exist on the license
// Instead theyre hardcoded in the 'limits' module
export const LicenseLimitTypes = [
  // Module - Requirement
  "requirement::frameworks", // Maximum number of frameworks in the system
  "requirement::objecttypes",
  // Module - Manual
  "manual::manuals", // Maximum number of manuals in the system
  // Module - Action
  "action::records", // Maximum number of actions in the system (excludes on::demand actions)
  "action::objecttypes", // Maximum number of action object types
  "action::ondemand-daily", // Maximum number of on-demand actions that can be run daily
  // Registers
  "register::records", // Maximum number of registers in the system
  "register::objecttypes", // Maximum number of register object types
  // Risk
  "risk::records", // Maximum number of risks in the system
  "risk::objecttypes", // Maximum number of risk object types
  // Issues
  "issue::records", // Maximum number of issues in the system
  "issue::objecttypes", // Maximum number of issue object types
  // Reports
  "report::count", // Maximum number of reports in the system
  // Admin
  "admin::storage", // Max storage for uploads, in MB
  "admin::template-records", // Maximum number of templates in the system
] as const;

export type LicenseLimitKeys = (typeof LicenseLimitTypes)[number];

const LicenseAccessTypes = [
  "risk", // Access to the entire risk module + risk reports
  "templates", // Access to template manaagement mode
  "customise", // Allowed to customise requirement tree + requirement tree actions
  "admin", // Access to most admin features
  "export", // Allowed to export data from the system
  "manual-history", // Access to advanced manual history
  "upgrade"
] as const;

export type LicenseAccessKeys = (typeof LicenseAccessTypes)[number];

export type AccountLicenseEntitlements = {
  accessTypes: LicenseAccessKeys[];
  limits: Record<LicenseLimitKeys, number>;
};
